import { useCallback, useState } from 'react';

export const useLoadWithErrorCatcher = () => {
    const [error, setError] = useState<unknown>(null);

    const loadWithErrorCatcher = useCallback(async (load: any) => {
        try {
            await load();
        } catch (error: unknown) {
            setError(error);
        }
    }, []);

    if (error) {
        throw error;
    }

    return loadWithErrorCatcher;
};
